import React from "react";

const Neurology = () => {
  return (
    <div className="max-w-3xl mx-auto  bg-white">
      {/* Header Section */}
      <h1 className="text-3xl font-bold text-center Neurology mb-2">
        Neurology
      </h1>
      <h2 className="text-lg font-semibold text-center Neurology mb-3">
        Consultant Neurologist
      </h2>

      {/* Doctor Image */}
      <div className="Neurology">
        <img
          src="doctoricon.png"
          class="consltnt-doctor-img"
          alt="Dr. PawanKalyan"
        />
      </div>

      {/* Doctor Description */}
      <p className="text-center Neurology mb-1 font-semibold">
        Dr. P. Prasanth Babu
      </p>
      <p className="text-center Neurology mb-4 text-sm">
        Specialist in Brain & Nerve Disorders
      </p>

      <p className="text-center text-gray-600 mb-6 leading-relaxed">
        <strong className="text-red-600">
          Dr. P. Prasanth Babu, MD, DM (Neurologist),
        </strong>{" "}
        provides expert diagnosis and treatment for a wide range of neurological
        conditions.
      </p>

      {/* Services Offered */}
      <h3 className="text-xl font-semibold Neurology mb-3">Services Offered</h3>

      <ul className="space-y-2 text-gray-700 list-disc pl-5 text-sm">
        <li>
          <strong>Stroke Management:</strong> Immediate and advanced care for
          paralysis and brain stroke patients.
        </li>
        <li>
          <strong>Headache & Migraine Treatment:</strong> Specialized evaluation
          and management for chronic headaches and migraines.
        </li>
        <li>
          <strong>Epilepsy (Fits) Treatment:</strong> Comprehensive diagnosis
          and long-term care for seizure disorders.
        </li>
        <li>
          <strong>Vertigo & Balance Disorders:</strong> Advanced evaluation for
          dizziness, imbalance, and giddiness.
        </li>
        <li>
          <strong>Neuropathy & Nerve Pain:</strong> Treatment for nerve
          weakness, numbness, and tingling sensations.
        </li>
        <li>
          <strong>Movement Disorders:</strong> Diagnosis and care for
          Parkinson’s disease and related motor problems.
        </li>
        <li>
          <strong>Back Pain & Neck Pain (Neurological Origin):</strong>{" "}
          Nerve-related pain evaluation and treatment.
        </li>
        <li>
          <strong>Memory Disorders & Dementia Care:</strong> Expert assessment
          for Alzheimer’s and memory-related issues.
        </li>
      </ul>

      {/* Consultation Timings */}
      <div className="mt-6 bg-red-50 p-3 rounded-lg text-center">
        <h3 className="text-lg font-semibold Neurology mb-1">
          Consultation Timings
        </h3>
        <p className="text-gray-700 text-sm">
          Every <strong>Saturday</strong> <br />
          From <strong>10:00 AM onwards</strong>
        </p>
      </div>
    </div>
  );
};

export default Neurology;
